import { Box } from "@mui/material";
import { PropsWithChildren } from "react";


export type TankRelationshipsContainerProps = {
};

export function TankRelationshipsContainer({
 children
} : PropsWithChildren<TankRelationshipsContainerProps>) {


    return (
        <Box 
            sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                flexShrink: 1,
                flexBasis: '100%',
                overflow: 'hidden',
                overflowY: 'auto',
                marginTop: 1
        }}>
        {children}
        </Box>

    )
}
